import React from "react";
import {useMessages} from "i18n";
import {NudgeRoot, ProPill, UpPill} from "./UpgradeHints.styles";

export {FreePill, ProPill} from "./UpgradeHints.styles";

/**
 * Upgrade affordances from the v3 design:
 *  - `ProPill` (design `.pro-pill`): the small gold tag naming the tier that unlocks the control it
 *    sits on. It has said more than "Basic" since api#443 gave the sheet Premium-only rows, and since
 *    ui#1203 the expiry rungs wear BASIC, PLUS and PREMIUM in one list — so this is a tier slot, not a
 *    fixed word. Its text is resolved by the surface's view-model, never picked at the render site.
 *  - `Nudge` (design `.nudge` + `.up-pill`): the inline gold-tinted strip with an "Upgrade" action,
 *    shown when a free user bumps into a paid-plan limit (recipients, size cap, locked options).
 */

/**
 * `FreePill` (design `.free-pill`): the mono teal "FREE" tag on the always-free "Email to people"
 * option row, mirroring {@link ProPill}'s shape for the paid options.
 */
interface NudgeProps {
	children: React.ReactNode;
	onUpgrade?: () => void;
}

export function Nudge({children, onUpgrade}: NudgeProps) {
	const {common} = useMessages();
	return (
		<NudgeRoot>
			<span>{children}</span>
			{onUpgrade ? <UpPill type="button" onClick={onUpgrade}>{common.upgrade}</UpPill> : null}
		</NudgeRoot>
	);
}
